<template>
  <b-card class="generic-counter stats-block" v-if="value">
    <b-row>
      <b-col col md="9">
        <span class="header secondary-color">Total <b>{{label}}</b></span>
      </b-col>
      <b-col col md="3" v-if="icon">
        <div class="round-icon" :style="{ 'background-color': color }"><font-awesome-icon :icon="icon"  /> </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col col lg="9"><h3>{{value}}</h3></b-col>
      <b-col col lg="2"></b-col>
    </b-row>
    <b-row>
      <b-col col lg="12">
        <div class="footer secondary-color"  v-if="percentageChange">
          <percentage-change :change="percentageChange" :percent="true" /> <span v-if="positive">more</span><span v-else>less</span> than last month
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import PercentageChange from '@/components/dashboard/percentage-change';

export default {
  name: 'generic-counter',
  props: {
    // Todo: change back to integer once number formatting is sorted
    icon: String,
    value: String,
    percentageChange: Number,
    color: String,
    label: String,
  },
  data() {
    return {
      percentageChangeAbs: Math.abs(this.percentageChange),
      positive: this.percentageChange >= 0,
      rotated: false
    };
  },
  methods: {
    rotate() {
      this.rotated = !this.rotated;
    }
  },
  components: { PercentageChange }
};
</script>
<style lang="scss">
.generic-counter {
  .round-icon {
    .svg-inline--fa {
      color: white;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/generic-counter.vue